import React, { useState, useEffect } from 'react';
import {
  Box, Button, Card, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, IconButton, Chip, Typography, Dialog,
  DialogTitle, DialogContent, DialogActions, TextField, FormControl,
  InputLabel, Select, MenuItem
} from '@mui/material';
import { Add, Edit, Delete } from '@mui/icons-material';
import { getUsers, createUser, updateUser, deleteUser } from '../services/api';

function UsersPage() {
  const [users, setUsers] = useState([]);
  const [dialog, setDialog] = useState({ open: false, user: null });
  const [deleteDialog, setDeleteDialog] = useState({ open: false, user: null });
  const [form, setForm] = useState({ name: '', email: '', password: '', role: 'editor' });

  useEffect(() => { loadUsers(); }, []);

  const loadUsers = async () => {
    try {
      const { data } = await getUsers();
      setUsers(data);
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const handleOpen = (user = null) => {
    if (user) {
      setForm({ name: user.name, email: user.email, password: '', role: user.role });
    } else {
      setForm({ name: '', email: '', password: '', role: 'editor' });
    }
    setDialog({ open: true, user });
  };

  const handleSave = async () => {
    try {
      const data = { ...form };
      if (!data.password) delete data.password;

      if (dialog.user) {
        await updateUser(dialog.user._id, data);
      } else {
        await createUser(data);
      }
      setDialog({ open: false, user: null });
      loadUsers();
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const handleDelete = async () => {
    try {
      await deleteUser(deleteDialog.user._id);
      setDeleteDialog({ open: false, user: null });
      loadUsers();
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const roleColors = { admin: 'error', editor: 'primary', reviewer: 'default' };
  const roleLabels = { admin: 'Administrateur', editor: 'Editeur', reviewer: 'Relecteur' };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" fontWeight="bold">Utilisateurs</Typography>
        <Button variant="contained" startIcon={<Add />} onClick={() => handleOpen()}>
          Nouvel utilisateur
        </Button>
      </Box>

      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Nom</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>Statut</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user) => (
                <TableRow key={user._id} hover>
                  <TableCell><Typography fontWeight="medium">{user.name}</Typography></TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell><Chip size="small" label={roleLabels[user.role]} color={roleColors[user.role]} /></TableCell>
                  <TableCell><Chip size="small" label={user.isActive ? 'Actif' : 'Inactif'} color={user.isActive ? 'success' : 'default'} /></TableCell>
                  <TableCell align="right">
                    <IconButton size="small" onClick={() => handleOpen(user)}><Edit /></IconButton>
                    <IconButton size="small" color="error" onClick={() => setDeleteDialog({ open: true, user })}><Delete /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      <Dialog open={dialog.open} onClose={() => setDialog({ open: false, user: null })} maxWidth="sm" fullWidth>
        <DialogTitle>{dialog.user ? 'Modifier' : 'Nouvel utilisateur'}</DialogTitle>
        <DialogContent>
          <TextField fullWidth label="Nom" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} margin="normal" required />
          <TextField fullWidth label="Email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} margin="normal" required />
          <TextField fullWidth label="Mot de passe" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} margin="normal" helperText={dialog.user ? 'Laisser vide pour ne pas changer' : ''} required={!dialog.user} />
          <FormControl fullWidth margin="normal">
            <InputLabel>Role</InputLabel>
            <Select value={form.role} label="Role" onChange={(e) => setForm({ ...form, role: e.target.value })}>
              <MenuItem value="admin">Administrateur</MenuItem>
              <MenuItem value="editor">Editeur</MenuItem>
              <MenuItem value="reviewer">Relecteur</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialog({ open: false, user: null })}>Annuler</Button>
          <Button variant="contained" onClick={handleSave}>Enregistrer</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialog.open} onClose={() => setDeleteDialog({ open: false, user: null })}>
        <DialogTitle>Confirmer la suppression</DialogTitle>
        <DialogContent>Supprimer "{deleteDialog.user?.name}" ?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialog({ open: false, user: null })}>Annuler</Button>
          <Button color="error" variant="contained" onClick={handleDelete}>Supprimer</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default UsersPage;
